import React from 'react';
import noImage from '../../assets/icons/no-image.jpg';
import { formatDistance } from '../../utils/formatters';
import { FormattedOpeningHours } from './FormattedOpeningHours';
import routeIcon from '../../assets/icons/route.svg';
import disabledIcon from '../../assets/icons/disabled.svg';

const POICard = ({ poi, isActive, onClick }) => {
  return (
    <div
      className={`place-card${isActive ? ' active' : ''}`}
      onClick={() => onClick(poi)}
    >
      <div className="place-card-left">
        <img
          src={poi.image_url && poi.image_url.trim() !== '' ? poi.image_url : noImage}
          className="place-img"
          alt={poi.poi_name}
          style={{ objectFit: (!poi.image_url || poi.image_url.trim() === '') ? 'contain' : 'cover' }}
        />
        <a 
          href={poi.google_maps_direction?.replaceAll(' ','')} 
          target="_blank" 
          className="direction-btn" 
          onClick={(e) => e.stopPropagation()}
        >
          <img src={routeIcon} alt="Directions" className="direction-icon" />
          Direction
        </a>
      </div>
      <div className="place-info">
        <div className="place-title">{poi.poi_name}</div>
        <div className="place-tags">
          {poi.distance != null && (
            <span className="tag distance-tag">
              {formatDistance(poi.distance)}
            </span>
          )}
          <span className="tag">{poi.poi_category}</span>
          {poi.entry_fee && <span className="tag">{poi.entry_fee}</span>}
          {poi.disable_access_y_n === "Yes" && (
            <span className="tag">
              <img src={disabledIcon} className="disabled-img" alt="disabled" />
            </span>
          )}
          {poi.opening_hours_days && (
            <FormattedOpeningHours hours={poi.opening_hours_days} />
          )}
        </div>
        {poi.poi_description && (
          <div className="place-desc">
            {poi.poi_description}
          </div>
        )}
      </div>
    </div>
  );
};

export default POICard; 